<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        การจัดการ กลุ่ม Device
      </span>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleAddTaHardwaresGroupForm">
        <v-icon small left>mdi-plus</v-icon>เพิ่มกลุ่ม Device
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="taHardwaresGroup"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <TaHardwareGroupForm
      :formShow="taHardwareGroupFormShow"
      :formAction="taHardwareGroupFormAction"
      :taHardwareGroup="taHardwareGroup"
      :taHardwareGroupInit="taHardwareGroupInit"
      @isTaHardwareGroupDataChange="handleTaHardwareGroupFormDataChange"
      @formActionCompleted="handleTaHardwareGroupFormActionCompleted"
      @onReset="handleTaHardwareGroupFormReset"
      @onClickAddTaHardware="taHardwareGroupAddShow = true"
      @addTaHardwareGroupSuccess="handleAddTaHardwareGroupSuccess"
    />
    <TaHardwareGroupAdd
      :formShow="taHardwareGroupAddShow"
      :taHardwareGroup="taHardwareGroup"
      :taHardwareGroupInit="taHardwareGroupInit"
      @isTaHardwareGroupAddDataChange="handleTaHardwareGroupAddDataChange"
      @onClickBlack="taHardwareGroupAddShow = false"
      @addTaHardwareGroupMemberSuccess="handleAddTaHardwareGroupMemberSuccess"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        (taHardwareGroupFormShow && taHardwareGroupFormAction === 'add') ||
        taHardwareGroupAddShow
      "
      z-index="0"
    ></v-overlay>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TaHardwareGroupAdd from '@/views/ta-hardwares-group/TaHardwareGroupAdd.vue'
import TaHardwareGroupForm from '@/views/ta-hardwares-group/TaHardwareGroupForm.vue'

export default {
  components: {
    TaHardwareGroupForm,
    TaHardwareGroupAdd,
    ConfirmDialog,
  },
  data() {
    return {
      sortBy: ['title_th'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      taHardwareGroupFormShow: false,
      taHardwareGroupAddShow: false,
      taHardwareGroupFormAction: '',
      taHardwareGroup: {},
      taHardwareGroupInit: {},
      isTaHardwareGroupDataChange: false,
      isTaHardwareGroupAddDataChange: false,
      timeout: null,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        {
          text: 'จำนวน Device',
          align: 'start',
          value: 'hardware_group_member.total',
        },
      ]
    },
    taHardwaresGroup() {
      return this.$store.state.taHardwaresGroup.taHardwaresGroup
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ กลุ่ม Device',
        disabled: true,
      },
    ])

    this.loading = true
    const { company_uuid } = this.$store.state.authentication.company

    Promise.all([
      this.fetchTaHardwaresGroup({ company_uuid }),
      this.fetchHardwareModels(company_uuid),
    ])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchTaHardwaresGroup: 'taHardwaresGroup/fetchTaHardwaresGroup',
      fetchHardwareModels: 'hardware/fetchHardwareModels',
    }),
    handleAddTaHardwareGroupMemberSuccess(taHardwareGroup) {
      this.taHardwareGroupAddShow = false
      this.taHardwareGroup = { ...taHardwareGroup }
      this.taHardwareGroupInit = { ...taHardwareGroup }
    },
    handleAddTaHardwareGroupSuccess(taHardwareGroup) {
      this.taHardwareGroup = { ...taHardwareGroup }
      this.taHardwareGroupInit = { ...taHardwareGroup }
    },
    classRowSelected(row) {
      if (this.taHardwareGroup.hardware_group_uuid === row.hardware_group_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (
        this.taHardwareGroup.hardware_group_uuid === row.hardware_group_uuid
      ) {
        this.taHardwareGroupFormShow = false
        this.taHardwareGroupFormAction = ''
        this.taHardwareGroup = {}
        this.taHardwareGroupInit = {}
      } else {
        this.taHardwareGroupFormShow = true
        this.taHardwareGroupFormAction = 'edit'
        this.taHardwareGroup = { ...row }
        this.taHardwareGroupInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isTaHardwareGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddTaHardwaresGroupForm() {
      this.taHardwareGroupFormShow = true
      this.taHardwareGroupFormAction = 'add'
      this.taHardwareGroup = {}
      this.taHardwareGroupInit = {}
    },
    handleTaHardwareGroupFormDataChange(value) {
      this.isTaHardwareGroupDataChange = value
    },
    handleTaHardwareGroupAddDataChange(value) {
      this.isTaHardwareGroupAddDataChange = value
    },
    handleTaHardwareGroupFormReset(formAction) {
      if (formAction === 'edit') {
        this.taHardwareGroup = { ...this.taHardwareGroupInit }
      }
    },
    handleTaHardwareGroupFormActionCompleted(formAction) {
      this.taHardwareGroup = {}
      this.taHardwareGroupInit = {}
      this.taHardwareGroupFormShow = false
      this.taHardwareGroupFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.taHardwareGroupFormShow = false
      this.taHardwareGroupAddShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.isTaHardwareGroupDataChange ||
      this.isTaHardwareGroupAddDataChange
    ) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
